'use client';

import Link from 'next/link';
import type { HTMLAttributeAnchorTarget, ReactNode } from 'react';

import type { ButtonProps } from '@/components/ui/button';
import { Button } from '@/components/ui/button';
import { cn } from '@/utils';

// TODO: replace label with children
export interface ButtonLinkProps extends Omit<ButtonProps, 'children' | 'onClick'> {
  label: ReactNode;
  href: string;
  setIsOpen?: (isOpen: boolean) => void;
  target?: HTMLAttributeAnchorTarget;
}

export const ButtonLink = ({ href, label, setIsOpen, className, target, disabled, ...props }: ButtonLinkProps) => {
  return (
    <Button
      onClick={() => setIsOpen && setIsOpen(false)}
      className={cn('font-semibold text-blue-400', className)}
      variant="tertiary"
      asChild={!disabled}
      disabled={disabled}
      {...props}
    >
      {disabled
        ? label
        : (
            <Link
              href={href}
              target={target}
            >
              {label}
            </Link>
          )}
    </Button>
  );
};
